import React from 'react';
import {useNavigate} from 'react-router-dom';

import {getPCFStepPath, type PCFStepKey} from './pcfRoutes';

const TABS: Array<{id: number; label: string; stepKey: PCFStepKey}> = [
  {id: 1, label: 'Goal & Scope', stepKey: 'goalAndScope'},
  {id: 2, label: 'LCI Data Collection', stepKey: 'lciDataCollection'},
  {id: 3, label: 'Impact Configuration', stepKey: 'impactConfiguration'},
  {
    id: 4,
    label: 'Results & Interpretation',
    stepKey: 'resultsInterpretation'
  },
  {id: 5, label: 'Report & Export', stepKey: 'reportExport'}
];

interface TabStepperProps {
  activeStep?: number;
  completedSteps?: number[];
  recordId?: string | null;
}

const TabStepper: React.FC<TabStepperProps> = ({
  activeStep = 1,
  completedSteps = [],
  recordId = null
}) => {
  const navigate = useNavigate();

  return (
    <div className="tab-stepper">
      {TABS.map((tab) => {
        const isActive = tab.id === activeStep;
        const isCompleted = completedSteps.includes(tab.id);

        return (
          <div
            key={tab.id}
            className={`pcf-stepper-tab ${isActive ? 'active' : ''} ${
              isCompleted ? 'completed' : ''
            }`}
            onClick={() => {
              navigate(getPCFStepPath(tab.stepKey, recordId));
            }}
            role="button"
            tabIndex={0}
          >
            <div className="pcf-stepper-tab-num">
              {isCompleted ? (
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 12L10 17L20 7"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <span>{tab.id}</span>
              )}
            </div>
            <span className="pcf-stepper-tab-label">{tab.label}</span>
            {isActive && <div className="pcf-stepper-tab-underline" />}
          </div>
        );
      })}
    </div>
  );
};
export default TabStepper;
